import "../styles.css"

export default function Welcome() {
  return (
    <div className="welcomeContainer">
      <h1 className='welcomeText' >  Welcome to Beta Boys Cards</h1>
      <div className='welcomeText'>
         As a good beta boy you probably already know about the world of our great future.<br></br>
         All boys have beta-chips installed in their heads and they are in control of women. <br></br>
         Recently, one game has become popular among beta boys. Beta Boys Cards, or just BBC. The rules are very simple. <br></br>
         1.Complete the mistress's tasks to get points.<br></br>
         2. Use points to buy boosters.<br></br>
         3. Get cards from booster packs. <br></br>
         4. Find rare cards wtth less censorship! <br></br>
         5. When mistress allows you to cum you can use your cards. <br></br>
         The reason why all beta boys actively play in BBC is that they have a tiny chance of seeing an explicit picture without censorship. <br></br>
          Go ahead, try it yourself!
      </div>

      <h1 className='welcomeText' >Disclamer</h1>
      <div className='welcomeText'>
         Please note, that I didnt mean to make tasks realistic.<br></br>
         First of all, it is just a game. <br></br>
         Take care and think about yourself and your health! <br></br>
      </div>

      <h1 className='welcomeText' >Feedback</h1>
      <div className='welcomeText'>
         If you have found any bugs or typos<br></br>
         Plese DM me on reddit, or write on my email ma4dro@gmail.com <br></br>
      </div>
    </div>
  );
}
